export default {
  status: 'Статус',
  route_task: 'Маршрутное задание',
  courier: 'Курьер',
  discard: 'Списание',
  workshop: 'Готовность блюд',
  operator: 'Оператор',
  client: 'Клиент',
  client_note: 'Примечания клиента к заказу',
  address: 'Адрес',
  address_note: 'Примечание к адресу',
  payment: 'Платежные данные',
  order_type: 'Тип заказа',
  delivery_date: 'Дата доставки',
  products: 'Блюда',
  manufacture: 'Производство',
  cell: 'Ячейка',
  remaking: 'Доготовка',
  order_source: 'Источник заказа'
}